module.exports = __webpack_public_path__ + "media/images/default_image-d98d4c7636a51e8661ff2446480c2300.jpg";